<template>
  <v-slide-x-transition>
    <v-breadcrumbs v-if="items.length" :items="items" divider=">">
      <template #item="{ item }">
        <component :is="item.to ? 'router-link' : 'span'" :to="item.to">
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
          {{ item.text }}
        </component>
      </template>
    </v-breadcrumbs>
  </v-slide-x-transition>
</template>

<script>
export default {
  computed: {
    baseItems() {
      return [
        {
          icon: "home",
          to: { name: "home" }
        },
        {
          text: "Clasificaciones",
          to: { name: "matching/classifications" }
        },
        {
          text: this.classificationId
        },
        {
          text: "Marcas",
          to: {
            name: "matching/brands",
            params: { classificationId: this.classificationId }
          }
        },
        {
          text: this.$route.params.brandName
        }
      ];
    },
    classificationId() {
      return this.$route.params.classificationId;
    },
    items() {
      switch (this.$route.name) {
        case "matching/classifications":
          return this.baseItems.slice(0, 1);
        case "matching/brands":
          return this.baseItems.slice(0, 3);
        case "matching/pivots":
        case "matching/qmps":
          return this.baseItems;
        default:
          return [];
      }
    }
  }
};
</script>